// Quick add for NRC product cards: adds to cart via AJAX and opens Dawn's cart drawer.
// Falls back to the normal form POST (cart page) if anything is missing.
if (!window.nrcQuickAdd) {
  window.nrcQuickAdd = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form.nrc-qa');
    if (!form) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    button.classList.add('is-loading');

    const body = new FormData(form);
    body.append('sections', drawer.getSectionsToRender().map((s) => s.id).join(','));
    body.append('sections_url', window.location.pathname);

    try {
      const res = await fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body,
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'Add to cart failed');
      drawer.classList.remove('is-empty');
      drawer.renderContents(data);
    } catch (err) {
      form.submit();
    } finally {
      button.classList.remove('is-loading');
    }
  });
}
